<script setup lang="ts">
import AppLogoIcon from "@/components/AppLogoIcon.vue"
</script>

<template>
  <div class="text-sidebar-primary-foreground flex aspect-square items-center justify-center rounded-md">
    <AppLogoIcon class="size-12 fill-current dark:text-white text-gray-900" />
  </div>
  <div class="ml-1 grid flex-1 text-left text-sm">
    <span class="mb-0.5 truncate leading-tight font-normal">
      Total Lifestyle Credit
    </span>
  </div>
</template>
